module.exports = __webpack_public_path__ + "static/beauty-our-portfolio-section-5f964d7939f9a88a7e40cc7c2b117868.png";